export const METADATA_KEYS = {
    SCHEMA: 'debugPanel:schema',
    GROUPS: 'debugPanel:groups',
};
function withSchema(target, cb) {
    const schema = Reflect.getMetadata(METADATA_KEYS.SCHEMA, target) || {};
    const updatedSchema = cb(schema) || schema;
    Reflect.defineMetadata(METADATA_KEYS.SCHEMA, updatedSchema, target);
}
export function title(titleText) {
    return (target, property) => {
        withSchema(target, (schema) => {
            const type = Reflect.getMetadata('design:type', target, property);
            schema[property] = Object.assign(Object.assign({}, schema[property]), { key: property, title: titleText, type });
            return schema;
        });
    };
}
export function group(groupName) {
    return (target, property) => {
        withSchema(target, (schema) => {
            schema[property] = Object.assign(Object.assign({}, schema[property]), { groupName });
            return schema;
        });
    };
}
export function description(descriptionString) {
    return (target, property) => {
        withSchema(target, (schema) => {
            schema[property] = Object.assign(Object.assign({}, schema[property]), { description: descriptionString });
            return schema;
        });
    };
}
export function persistent(target, property) {
    withSchema(target, (schema) => {
        schema[property] = Object.assign(Object.assign({}, schema[property]), { persistent: true });
    });
}
export function requiresReload(target, property) {
    withSchema(target, (schema) => {
        schema[property] = Object.assign(Object.assign({}, schema[property]), { requiresReload: true });
    });
}
//# sourceMappingURL=decorators.js.map